'use client';

import { BaseLayout } from 'structure/Layouts/SFILayouts/BaseLayout/BaseLayout';
import NotFound from 'components/NotFound';

export default function NotFoundPage() {
  return (
    <BaseLayout>
      <NotFound />
    </BaseLayout>
  );
}
